import { DEFINITIONS_BASE_PATH } from './definitions-base-path.js';

const base = `${DEFINITIONS_BASE_PATH}/document`;

export const documentTabsConfig = {
  basePath: base,
  tabs: [
    {
      id: "document-type",
      path: `${base}/document-type`,
      pageKey: "definitionsDocumentDocumentType",
    },
    {
      id: "classification",
      path: `${base}/classification`,
      pageKey: "definitionsDocumentClassification",
    },
  ],
};
